import { useRoute } from "wouter";
import { ProjectInfo } from "../components/ProjectInfo";
import { AnimatePresence } from "framer-motion";

export function ProjectInfoScreen() {
	const [radarMatch] = useRoute("/tech-radar/project-info");
	const [breakdownMatch] = useRoute("/score-breakdown/project-info");
	return (
		<AnimatePresence initial={false} exitBeforeEnter={true}>
			{radarMatch || breakdownMatch ? (
				<ProjectInfo key={"project-info"} />
			) : null}
		</AnimatePresence>
	);
}
